import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const deleteSettlementReq = (data: any, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.deleteSettlementReport,
    method: 'POST',
    config: sitConfig(tokens),
    body: data,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { deleteSettlementReq }
